import {
  AccredibleOpenSearchApiTextSearchQuery,
  AccrediblePageMeta,
  CustomAttribute,
  CustomAttributeFilter,
} from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  SpotlightProfile,
  SpotlightProfilesApiSearchParams,
  SpotlightProfilesFilters,
  SpotlightSearchByOptions,
} from '../../../../core/models/spotlight-profiles.model';
import { SpotlightApiService } from '../../../../shared/services/sl-api/sl-api.service';

@Injectable({
  providedIn: 'root',
})
export class SpotlightProfilesApiService extends SpotlightApiService {
  loadSpotlightProfiles(
    directoryId: number,
    filters: SpotlightProfilesFilters,
  ): Observable<{ meta: AccrediblePageMeta; profiles: SpotlightProfile[] }> {
    // We need to map the custom_attributes to the format that the BE require here
    const { search_term, search_by, country, city, state, ...restOfFilters } = filters;
    const filterData = <SpotlightProfilesApiSearchParams>{
      ...restOfFilters,
      custom_attributes: filters.custom_attributes
        ? buildIdValueArray(filters.custom_attributes)
        : null,
      text_search_query: buildTextSearch(search_term, search_by),
      location: state ? `${state}, ${country}` : country || city,
      // Only send viewport to API if user is filtering by country/state
      viewport: filters.country ? filters.viewport : null,
    };
    const url = `/v1/recipient/spotlight_directories/${directoryId}/users/search`;

    return this._post(url, filterData).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}

const buildTextSearch = (
  searchTerm: string,
  searchBy: SpotlightSearchByOptions,
): AccredibleOpenSearchApiTextSearchQuery => {
  if (!searchTerm) {
    return <AccredibleOpenSearchApiTextSearchQuery>{};
  }

  return {
    fields: searchBy ? [searchBy] : ['name'],
    value: searchTerm,
  };
};

const buildIdValueArray = (customAttributes: CustomAttribute[]): CustomAttributeFilter[] => {
  // Loop through all the custom attribute values
  return customAttributes.reduce((filter, el) => {
    // If the custom attribute has a value
    if (el?.value) {
      // If the value is not an array, or it is an array with at least one element
      if (!Array.isArray(el.value) || (Array.isArray(el.value) && el.value.length > 0)) {
        // If the value is a number when pushed it should be a single item array
        filter.push({ id: el.id, value: Number.isInteger(el.value) ? [el.value] : el.value });
      }
    }
    return filter;
  }, []);
};
